// extracted by mini-css-extract-plugin
export default {"wrapper":"ExtendedDatePicker_wrapper__KcXn3","datePicker":"ExtendedDatePicker_datePicker__LtLuW"};